import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Grid,
  Box,
  Checkbox,
  FormControlLabel,
  Typography
} from "@mui/material";
import { Download } from "@mui/icons-material";

import {
  tryExportStudents,
  tryGetExportFields,
} from "../../../store/slices/backoffice-students";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  margin: "auto",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ModalExportFilter = ({ open, setOpen }) => {
  const dispatch = useDispatch();

  const [selectedFields, setSelectedFields] = useState([]);
  const [exportFields, setExportFields] = useState([]);

  useEffect(() => {
    if (!open) return;

    const getExportFields = async () => {
      const action = await dispatch(tryGetExportFields());

      if (action.payload?.data?.isValid) {
        setExportFields(action.payload.data.data || []);
      }
    };

    getExportFields();
  }, [open, dispatch]);

  useEffect(() => {
    if (!open) {
      setSelectedFields([]);
    }
  }, [open]);

  const handleCheckboxChange = (field) => {
    setSelectedFields((current) => {
      if (current.includes(field)) {
        return current.filter((item) => item !== field);
      }

      return [...current, field];
    });
  };

  const handleClickExport = async () => {
    const fieldsString = selectedFields.join("|");
        console.log(fieldsString)
    const action = await dispatch(
      tryExportStudents(fieldsString)
    );

    if (action.payload?.data?.isValid) {
      window.open(action.payload.data.data.file);
    }
  };

  if (!open) return null;
  return (
  <Box
    sx={style}
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography align="left"
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 1, fontStyle: "italic" }}
        >
          *Filtros opcionales
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            rowGap: 1,
          }}
        >
          {Object.entries(exportFields).map(([key, value]) => (
            <Box
              key={key}
              sx={{
                width: "33.33%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                sx={{ marginLeft: 0, marginRight: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={selectedFields.includes(key)}
                    onChange={() => handleCheckboxChange(key)}
                  />
                }
                label={value}
              />
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 1 }}>
        <Button
          variant="contained"
          fullWidth
          endIcon={<Download />}
          onClick={handleClickExport}
        >
          EXPORTAR
        </Button>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 1 }}>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="error"
          size="large"
          fullWidth
        >
          CERRAR
        </Button>
      </Grid>
    </Grid>
  </Box>
  );
};

export default ModalExportFilter;
